const ORAKLE_BASE_URL = 'https://orakle.powertrip.earth'

export const ORAKLE_VEHICLE_STATUS_ENDPOINT = ORAKLE_BASE_URL + '/fleet-overview'
